import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import PostJob from "@/pages/PostJob";
import Membership from "@/pages/Membership";
import { Login, Register, ForgotPassword, ResetPassword } from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import EmployerDashboard from "@/pages/EmployerDashboard";
import ApplicantDashboard from "@/pages/ApplicantDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { RenewJob, RenewMembership } from "@/pages/Renew";
import { Terms, Privacy } from "@/pages/Legal";

const EMPLOYER_ROLES = ["employer", "admin"];
const APPLICANT_ROLES = ["applicant", "admin"];
const ADMIN_ROLES = ["admin"];

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/jobs/:jobId" element={<JobDetail />} />
      <Route path="/post-job" element={<PostJob />} />
      <Route path="/membership" element={<Membership />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/renew/job/:jobId" element={<RenewJob />} />
      <Route path="/renew/membership" element={<RenewMembership />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/employer" element={<ProtectedRoute roles={EMPLOYER_ROLES}><EmployerDashboard /></ProtectedRoute>} />
      <Route path="/applicant" element={<ProtectedRoute roles={APPLICANT_ROLES}><ApplicantDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute roles={ADMIN_ROLES}><AdminDashboard /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
